import usePermissions from '../../hooks/permissions-hooks';

function PermissionsComponent({ permissions, fallback, ...props }) {
  const { hasPermissions } = usePermissions();

  if (hasPermissions(permissions)) {
    return props.children || null;
  }

  return fallback || null;
}

export default PermissionsComponent;
